<template>
    <div class="main-wrapper home-nine">
        <app-beranda-direktori v-if="baseData.apps" :directoryData="baseData.apps" />
    </div>
</template>

<script>

import AppBerandaDirektori from './section/beranda-direktori.vue';

import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
            isloading: false,
        }
    },
    components: {
        AppBerandaDirektori,
    },
    computed: {
        ...mapState('homePage', {
            baseData: (state) => state.home
        })
    },
    methods: {
        ...mapActions('homePage', ['getHomePages']),
        ...mapActions('login', ['me']),

        closeModal() {
            this.isSplashScreen = false
        },
    },
    async mounted() {
        this.isloading = true;
        try {
            if (localStorage.getItem('auth_token') != "null") {
                try {
                    const response = await this.me();

                    if (response.data) {
                        localStorage.setItem('users-info', JSON.stringify(response.data))
                    }
                } catch (err) {
                    localStorage.removeItem('auth_token')
                    localStorage.removeItem('users-info')
                    localStorage.removeItem('users-info-jf')
                }
            }

            await this.getHomePages();
        } catch (err) {
            console.error(err)
        }
        finally {
            this.isloading = false;
        }
    },
}

</script>